// extracted by mini-css-extract-plugin
export default {"creditCard":"YK-z","expired":"ZK-z"};